"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentSavedEventHandler = exports.moduleSavedEventHandler = void 0;
const Survicate_1 = require("configs/Survicate");
const ContentService_1 = __importDefault(require("../ContentService"));
const ModuleEditorParamsUtils_1 = __importDefault(require("../moduleEditor/ModuleEditorParamsUtils"));
class ResourceSavedEventHandler {
    constructor(eventName) {
        this.eventName = eventName;
    }
    callback(event) {
        var _a;
        const seasonId = ModuleEditorParamsUtils_1.default.getSeasonParam();
        const { isModuleUpdate, moduleId, isExtraModule } = event.detail;
        ContentService_1.default.lastEditedModule = null;
        ContentService_1.default.lastCreatedModule = null;
        ContentService_1.default[isModuleUpdate ? 'lastEditedModule' : 'lastCreatedModule'] =
            moduleId;
        ContentService_1.default.fetchModulesList(seasonId, isExtraModule);
        if ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.surveyEvent) {
            (0, Survicate_1.invokeEvent)(event.detail.surveyEvent);
        }
    }
    register() {
        window.addEventListener(this.eventName, this.callback);
    }
    unregister() {
        window.removeEventListener(this.eventName, this.callback);
    }
}
exports.moduleSavedEventHandler = new ResourceSavedEventHandler('app-content-admin:module:saved');
exports.contentSavedEventHandler = new ResourceSavedEventHandler('app-content-admin:content:saved');
